package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail

import kotlinx.serialization.Serializable


@Serializable
data class Img(
    val url: String ?=""
)